import { APIOrganizationUser, ArdoqId, OrgAccessLevel } from '@ardoq/api-types';
import { ApiResponse } from './types';
import {
  fetchBlob,
  fetchJson,
  fetchVoid,
  headers,
  Method,
  toRequestOptions,
} from './api';

/**
 * @deprecated Use fetchAllUsers instead.
 * Fetch all member in an organization (excluding contributors).
 */
const fetchAllMembers = (
  orgId: ArdoqId
): ApiResponse<APIOrganizationUser[]> => {
  const request = new Request(`/api/organization/${orgId}/users`, {
    headers,
  });
  return fetchJson<APIOrganizationUser[]>(request);
};

/**
 * Fetch all users in an organization including contributors.
 */
const fetchAllUsers = (orgId: ArdoqId): ApiResponse<APIOrganizationUser[]> => {
  const request = new Request(`/api/organization/${orgId}/all-users`, {
    headers,
  });
  return fetchJson<APIOrganizationUser[]>(request);
};

/**
 * Fetch all org admins in an organization.
 *
 * @Note This fetch is authorized for all roles (contributor+),
 * as opposed to `/all-users` which is not accessible for contributors.
 */
const fetchAllOrgAdmins = (
  orgId: ArdoqId
): ApiResponse<APIOrganizationUser[]> => {
  const request = new Request(`/api/organization/${orgId}/admins`, {
    headers,
  });
  return fetchJson<APIOrganizationUser[]>(request);
};

/**
 * Export all users in an organization including contributors.
 */
const exportAllUsersExcel = (orgId: ArdoqId): ApiResponse<Blob> => {
  const request = new Request(`/api/organization/${orgId}/all-users/export`, {
    headers,
  });
  return fetchBlob(request);
};

const revokeMembership = async (
  orgId: ArdoqId,
  userId: ArdoqId
): ApiResponse<void> => {
  const request = new Request(
    `/api/organization/${orgId}/users/${userId}`,
    toRequestOptions(Method.DELETE, {})
  );
  return fetchVoid(request);
};

const updateRole = async (
  orgId: ArdoqId,
  userId: ArdoqId,
  role: OrgAccessLevel
): ApiResponse<APIOrganizationUser> => {
  const request = new Request(
    `/api/organization/${orgId}/users/${userId}`,
    toRequestOptions(Method.PUT, { _id: userId, role })
  );
  return fetchJson<APIOrganizationUser>(request);
};

export const membershipApi = {
  exportAllUsersExcel,
  /**
   * @deprecated Use fetchAllUsers instead.
   *
   * Fetch all member in an organization (excluding contributors).
   */
  fetchAllMembers,
  /**
   * Fetch all users in an organization including contributors.
   */
  fetchAllUsers,
  /**
   * Fetch all org admins in an organization.
   */
  fetchAllOrgAdmins,
  revokeMembership,
  updateRole,
};
